import styled, { css } from 'styled-components';

export const StyledTable = styled.div<{
  displayMode?: 'flex' | 'table';
}>`
  ${({ displayMode }) => displayMode === 'table' && css`
    display: table;
    border-collapse: collapse; 
  `}
`;
